import { request } from '@umijs/max';

export async function getTwilioAccessToken(identity?: string) {
  return request('/api/twilio/tenant_access_token', {
    method: 'GET',
    params: { identity },
    withToken: true,
  });
}


export async function getMyTwilioNo() {
  return request('/api/twilio/get_my_twilio_no', {
    method: 'GET',
  });
}

export async function getMyRecentCalls(limit?: number) {
  return request('/api/twilio/get_my_recent_calls', {
    method: 'GET',
    params: { limit: limit || 20 },
  });
}

// Save/update free-text notes on a call log (keyed by Twilio call SID).
export async function saveCallLogNotes(data: { call_sid: string; notes: string }) {
  return request('/api/twilio/call_notes', {
    method: 'PUT',
    data,
  });
}

// Whether the notes editor may be shown for a call. Internal agent-to-agent
// calls share one call-log row (the caller's), so the receiving side is not
// allowed to attach notes — it would overwrite the caller's.
export async function checkCallNotesEligibility(call_sid: string) {
  return request('/api/twilio/call_notes_eligibility', {
    method: 'GET',
    params: { call_sid },
  });
}

export type CallActivityEvent = {
  event_type:
    | 'offer_received'
    | 'accept_click'
    | 'reject_click'
    | 'hangup_click'
    | 'hold_click'
    | 'resume_click'
    | 'notify_failed'
    | 'action_forwarded';
  call_sid?: string | null;
  customer_phone?: string | null;
  call_source?: string | null;
  details?: Record<string, any>;
};

// Track 2 evidence log: what the CSR's widget actually saw and did, written
// locally FIRST (before any forwarding to the Appointment Center). Fire and
// forget — evidence logging must never break call handling, so failures are
// swallowed after a console warning.
export async function recordCallActivity(event: CallActivityEvent): Promise<void> {
  try {
    await request('/tenant/twilio/call-activity', {
      method: 'POST',
      data: { ...event, client_time: new Date().toISOString() },
    });
  } catch (e) {
    console.warn('[CallActivity] failed to record', event.event_type, e);
  }
}